const ASSET_TYPE = {
  IMAGE: 'image',
  CUSTOM_ELEMENT: 'custom_element',
  TEXT: 'text',
};

export { ASSET_TYPE };
